import 'selectboxit/src/javascripts/jquery.selectBoxIt'; // selectBoxIt plugin
import pickmeup from 'pickmeup/dist/pickmeup.min'; // pickMeUp plugin

import Validation from '../validation/validation';

export default new class Form {
  /**
     * field - special item of form. This object consist of types
     * of field (tel, password, zip and etc)]
     * Each type consist of selector and pattern for jQuery mask (plugin)
     * Selector is required to initialize the field
     */
  constructor() {
    this.customSelect = {
      className: 'js-selectBoxIt',
      config: {},
    };

    this.pickMeUpCalendar = {
      className: 'js-pickMeUpCalendar',
      config: {
        locale: 'ru',
        hide_on_select: true,
        default_date: false,
      },
    };

    /* Other special ClassName */
    this.viewPassword = 'js-view-password';

    this.clearInputFileBtn = 'js-clearInputFile';

    /* Methods */
    this.initMasks();
    this.initCustomSelect();
    this.initCalendar();
    this.bindEvents();
  }

  /**
     * Init jQuery masks
     */
  initMasks() {
    $('.js-tel').mask('+375 (00) 000-00-00', { placeholder: '+375 (__) ___-__-__' });
    $('.js-unp').mask('000000000', { placeholder: '_________' });
    $('.js-yearMask').mask('0000', { placeholder: '____' });
    $('.js-zip').mask('000000', { placeholder: '______' });
  }

  /**
     *  Init selectBoxIt custom select
     */
  initCustomSelect() {
    const $selects = $(`select.${this.customSelect.className}`);

    $selects.selectBoxIt(this.customSelect.config);
  }

  /**
     *  Refresh selectBoxIt custom select
     */
  refreshSelectBoxIt() {
    const $selects = $(`select.${this.customSelect.className}`);

    for (let i = 0; i < $selects.length; i += 1) {
      $($selects[i]).selectBoxIt(this.customSelect.config).data('selectBoxIt').refresh();
    }
  }

  /**
     *  Init pickMeUpCalendar custom select
     */
  initCalendar() {
    const $calendar = $(`.${this.pickMeUpCalendar.className}`);

    if (!$calendar.length) return;

    pickmeup.defaults.locales.ru = {
      days: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
      daysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
      daysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
      months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
      monthsShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    };

    pickmeup(`.${this.pickMeUpCalendar.className}`, this.pickMeUpCalendar.config);
  }

  /**
     *  Refresh selectBoxIt
     */
  refreshSelectBox() {
    const selects = $(':selectBox-selectBoxIt');

    selects.each(function addData() {
      // Calls the refresh method on each select box element
      const select = $(this).data('selectBoxIt');

      select.refresh();
    });
  }

  /**
     * Init JS events
     */
  bindEvents() {
    this.enablePasteToField();

    $(document)
      .on('touchstart click', `.${this.clearInputFileBtn}`, (e) => {
        this.clearFileInput($(e.currentTarget));
      })
    // prevent write more than 10 symbols in calendar input
      .on('input', `.${this.pickMeUpCalendar.className}`, (e) => {
        if (e.target.value.length > 10) {
          e.target.value = e.target.value.substring(0, 10);
        }
      })
    // show/hide password in reg modal
      .on('click', `.${this.viewPassword}`, (e) => {
        const $password = $(e.target).closest('.form-item__field').find('.js-password');

        if ($password.attr('type') === 'password') {
          $password.attr('type', 'text');
        } else {
          $password.attr('type', 'password');
        }
      });
  }

  enablePasteToField() {
    $('.js-tel').on('paste', (e) => {
      $(e.currentTarget).val('');
    });
  }

  clearFileInput($deleteBtn) {
    const $inputFile = $deleteBtn.closest('.form-item').find('.form-item__item');

    $inputFile.val('');
    $inputFile.trigger('change');
  }

  /**
     * Toggle items in $formElementList disable/enable
     *
     * @param $formElementListList - arr of jQuery objs to disable/enable
     * @param isDisabled - boolean, set $formElements item disabled/enabled
     */
  toggleDisableFormElement($formElementListList, isDisabled) {
    for (let i = 0; i < $formElementListList.length; i += 1) {
      $($formElementListList[i]).prop('disabled', isDisabled);
    }
  }

  /**
     * add/remove disable for inputs in $container, show/hide $container
     *
     * @param $container - container with inputs to show/hide
     * @param isHide - flag to show/hide $container, add/remove disabled to
     * inputs  true - hide, false - show
     */
  toggleFormDisable($container, isHide) {
    this.toggleFieldsDisable($container, isHide);

    Validation.removeErrorFromFields($container);

    if (isHide) {
      $container.addClass('hidden');
      return;
    }

    $container.removeClass('hidden');
  }

  /**
     * add/remove disable for inputs in $container
     */
  toggleFieldsDisable($container, isHide) {
    const $inputs = $container.find('input');

    for (let i = 0; i < $inputs.length; i += 1) {
      const $currentInput = $($inputs[i]);

      $currentInput.attr('disabled', isHide);
    }
  }

  /**
     * Remove all values from inputs and textareas, set first option in select selected
     *
     * @param $form - jQuery object of form to clear
     */
  clearForm($form) {
    // clear input, textarea value
    const $formInputsArr = $form.find('textarea, input');

    for (let i = 0; i < $formInputsArr.length; i += 1) {
      // clear all inputs val !but not button
      if ($($formInputsArr[i]).attr('type') !== 'submit' && $($formInputsArr[i]).attr('type') !== 'button') {
        $formInputsArr[i].value = '';
      }
    }

    // set first option selected, unselect else options
    const $formSelectsArr = $form.find('select');
    for (let i = 0; i < $formInputsArr.length; i += 1) {
      const currentSelect = $($formSelectsArr[i]);

      const $optionsArr = currentSelect.find('option');
      for (let j = 0; j < $optionsArr.length; j += 1) {
        const currentOption = $($optionsArr[j]);
        if (j === 0) {
          currentOption.selected = true;
        } else {
          currentOption.selected = false;
        }
      }
    }

    // set checkboxes unchecked
    const $checkboxesArr = $form.find('input[type="checkbox"]');
    for (let i = 0; i < $checkboxesArr.length; i += 1) {
      $($checkboxesArr).attr('checked', false);
    }
  }

  /**
     * Adds $block in the $container
     *
     * @param $block - jQuery obj, block to add
     * @param $container - jQuery obj, container to add into
     * @param callback - function to run after append (init mask, validation etc..)
     */
  addBlockToContainer($block, $container, callback) {
    const $newBlock = $block.clone();

    this.clearForm($newBlock);

    if ($newBlock.find('select')) { // if container has selects, do some to set default settings for them
      $newBlock.find('.selectboxit-container').remove();
      $newBlock.find('select').prop('disabled', false);
      $newBlock.find('.checkbox__item').prop('checked', false);
    }

    Validation.removeErrorFromFields($newBlock);
    $container.append($newBlock);

    if (callback) {
      callback();
    }
  }
}();
